import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    buttonLabel: string;
    nbsp: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button text for the member access dialog button that adds members to a resource */
            buttonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessDialogButton.buttonLabel?c=295qccw425qqf", defaultMessage: "Add" }));
                },
                enumerable: true,
                configurable: true
            },
            /** @notranslate */
            nbsp: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessDialogButton.nbsp?c=bpjamrhgpmf5", defaultMessage: "\u00A0" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
